import { useState } from "react"
import { FaCircle } from "react-icons/fa"
import { FiTrash2 } from "react-icons/fi"
import classes from '../AddJob.module.css'
interface IListItemsProps{
    data: [] | string[],
    onAdd: (value: string)=>void
    onDelete?: (value: string)=>void,
    disabled?: boolean 
  }
  
  
 export const ListItems: React.FC<IListItemsProps> = (props)=>{
  
    const [value, setValue] = useState<string>('')
  
    const onClickAdd = ()=>{
      if(props.disabled) return
      props.onAdd(value.trim())
      setValue('')
    }
  
    return(
      <div style={styles.tags}>
                <div style={styles.displayTags}>
                     {props.data.map(d=><ListWithDelete disabled={props.disabled} onDelete={props?.onDelete} value={d} key={d} />)}
                </div>
                <div style={styles.inp}>
                <input 
                    style={{
                      width: '100%', 
                      textAlign: 'right', 
                      direction: 'rtl', 
                      borderLeft: 0, 
                      borderTopLeftRadius: 0, 
                      borderBottomLeftRadius: 0}} 
                    placeholder='اكتب هنا للإضافة'
                    className={classes.myInput}
                    onChange={({target})=>setValue(target.value)}
                    value={value}
                    disabled={props.disabled}
                />
                <button onClick={onClickAdd} className={classes.addBtn}>
                  <span>اضافة</span>
                </button>
                </div>
      </div>
    )
  }
  
  
  interface ListWithDeleteProps{
    onDelete?: (value: string)=>void,
    value: string,
    disabled?: boolean 
  }
  
  
  const ListWithDelete: React.FC<ListWithDeleteProps> = (props)=>{
    const onDelete = ()=>props.onDelete && props.onDelete(props.value)
    return(
    <div style={styles.HoursContainer}>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end'}}> 
        <div style={{width: 250, overflowWrap: 'break-word'}}>
          <p style={styles.HoursP}>{props?.value}</p>
        </div>
          <FaCircle size={10} color='wheat'/>
        </div>
        {props.onDelete && !props.disabled && <FiTrash2 onClick={onDelete} color='red' size={18} />}
    </div>
  )}


  const styles: any = {
    tags: {
      width: '90%',
      maxWidth: 360, 
      maxHight: 190, 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'center'
  },
  displayTags: {
      overflow: 'auto', 
      borderRadius: 4,
      marginBottom: 15
  },
  inp: {
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      flexDirection: 'row-reverse'
  },
  HoursContainer: {
    alignSelf: 'center', 
    display: 'flex', 
    flexDirection: 'row-reverse', 
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 7,
},
HoursP: {
   padding: 0, 
   margin: 0, 
   marginLeft: 12, 
   marginRight: 5,
   textAlign: 'right',
   fontSize: 16,
   color: '#fff'
}
}

